import type { PatternKey } from '../components/pattern/pattern';

export interface GameTheme {
    name: string;
    label: string;
    pattern: PatternKey;
}

export const Themes: GameTheme[] = [
    {
        name: 'light',
        label: 'Light',
        pattern: 'i-like-food',
    },
    {
        name: 'dark',
        label: 'Dark',
        pattern: 'piano-man',
    }
];
